import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const faqs = [
    {id: 1, question: 'What is the validity of the FREE membership?', answer: '1-year validity only. After 1 year, the membership needs to be renewed.'},
    {id: 2, question: 'How will I know if my membership had expired?', answer: 'You will be receiving an email and SMS notification.'},
    {id: 3, question: 'Can I register 2 or more cars under my name?', answer: 'Yes, the membership is on a per person basis, not per vehicle.'},
    {id: 4, question: 'Can I use my Digital ID on different branches?', answer: 'No, this is not allowed. You can only use your Digital ID on one branch to avoid loss of points. Your points will reset to 0 if you use your Digital ID to different branches.'},
    {id: 5, question: 'How can I receive my Digital ID?', answer: 'You will receive it via SMS within the day after you signed up. Kindly download it so you can present it on your next visit to any Rapide branch.'},
    {id: 6, question: 'How to check my points?', answer: 'You can email us at club@rapide.com.ph to ask about your points. You will also be receiving an SMS from us regarding your total earned points and how much discount you can use, upon store visit.'},
    {id: 7, question: 'How can I claim my discount?', answer: 'Just present your Digital ID.'},
];

export default function Faqs(){
    const [faqOpen, setFagOpen] = useState(null);
    return(
        <section id="faqs" className='lg:scroll-mt-[150px] md:scroll-mt-[140px] sm:scroll-mt-[130px] scroll-mt-[80px] snap-normal snap-start w-full bg-white md:py-4 py-4 border-t border-gray-200'>
            <div className='max-w-screen-xl mx-auto md:px-12 px-4 py-4'>
                <h1 className='text-5xl text-center pb-4'>Frequently Asked Questions</h1>
                <div className='grid sm:grid-cols-2 grid-cols-1 gap-4'>
                    {faqs.map((faq, index) => {
                        return(
                            <div key={index}>
                                <motion.header
                                    className={`${faq.id == faqOpen ? 'rounded-t-md text-white' : 'rounded-md text-black'} relative cursor-pointer  bg-rapide-black`}
                                    initial={false}
                                    animate={{ backgroundColor: faq.id == faqOpen ? "#000000" : "#f7e332" }}
                                    onClick={() => {setFagOpen(faq.id)}}
                                >
                                    <h1 className='px-4 py-2'>{faq.question}</h1>
                                    <span className='absolute top-3 right-0 w-6 h-6 '>
                                        <svg className={`${faq.id == faqOpen ? '-rotate-180' : 'rotate-0'} duration-200 transition-all transform`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                        </svg>
                                    </span>
                                </motion.header>
                                <AnimatePresence initial={false}>
                                    {faq.id == faqOpen && (
                                        <motion.section
                                            className='px-4 py-2 border border-rapide-yellow rounded-b-md'
                                            key="content"
                                            initial="collapsed"
                                            animate="open"
                                            exit="collapsed"
                                            variants={{
                                            open: { opacity: 1, height: "auto" },
                                            collapsed: { opacity: 0, height: 0 }
                                            }}
                                            transition={{ duration: 0.8 }}
                                        >
                                            <h1>{faq.answer}</h1>
                                        </motion.section>
                                    )}
                                </AnimatePresence>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}